<ion-header>
	<ion-toolbar>
		<ion-title>Manage Templates</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="close()" color="primary">
				<ion-icon slot="icon-only" name="close-sharp"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>
<div class="container" *ngrxLet="sheetTemplates$ as templates; suspenseTpl: loading">
	<div class="scroll-vertical app-padding">
		<div class="form-section">
			<div class="form-group">
				@for (template of templates; track template.id) {
					<app-item class="rounded-border-box" @enterLeaveFast>
						<app-item-label (click)="presentRenameAlert(template)">{{ template.name }}</app-item-label>
						<app-item-note>{{ template.createdDate | isoDateToRelative: 'dd/MM/yyyy' : TimeDisplay.After }}</app-item-note>
						<div class="checkbox" (click)="presentActivationAlert(template, $event)">
							<app-item-checkbox [checked]="template.isActive"></app-item-checkbox>
						</div>
						<app-svg-icon name="close-sharp" (click)="presentDeleteAlert(template, $event)"></app-svg-icon>
					</app-item>
				}
			</div>
		</div>
	</div>
</div>
<ng-template #loading>
	<app-spinner class="margin-top"></app-spinner>
</ng-template>